<template>
  <v-container class="ma-0 pa-0" v-if="scheduleParams">
    <v-progress-linear indeterminate :active="loading" class="mt-1" />

    <!-- speciality -->
    <v-row no-gutters align="center" justify="space-around" class="pa-0 ma-0 pb-5">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pa-0 ma-0 pb-2 caption"
        v-if="scheduleParams.calendarId">
       <calendar-get-date v-model="date" :calendarId="scheduleParams.calendarId"
        :type="(scheduleParams.regress) ? 'regress' : 'normal'" />
      </v-col>
    </v-row>

    <v-row no-gutters align="center" justify="space-around" class="pa-0 ma-0 pb-5">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pa-0 ma-0 pb-2 caption"
        v-if="date != null && scheduleParams.calendarId != null">
        <calendar-get-time v-model="time" :date="date" :calendarId="scheduleParams.calendarId"
          :type="(scheduleParams.regress) ? 'regress' : 'normal'" />
      </v-col>
    </v-row>

    <v-row no-gutters align="center" justify="space-around" class="pa-0 ma-0 pb-5">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pa-0 ma-0 pb-2 caption">
        <mb-text-button name="csc_schedule" label="Agendar" :disabled="time == null"
          @click="schedule" />
      </v-col>
    </v-row>

    <!-- <v-dialog v-model="confirmDialog" max-width="400" >
      <v-card>
        <v-card-text class="pa-5">
          <schedule-confirm v-if="confirmDialog" :params="scheduleParams" :calendar="calendar"
            @cancel="confirmDialog = false" @scheduled="scheduled" />
        </v-card-text>
      </v-card>
    </v-dialog> -->

  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import CalendarGetTime from '@/components/calendars/CalendarGetTime';
import CalendarGetDate from '@/components/calendars/CalendarGetDate';
// import ScheduleConfirm from '@/components/calendars/ScheduleConfirm';

export default {
  props: {
    value: {
      type: Object,
    },
    calendar: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    scheduleParams: null,
    date: null,
    time: null,
    loading: false,
    removeLoading: false,
    confirmRemove: false,
    pickerDate: null,
    scheduleLoading: false,
    // confirmDialog: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.scheduleParams = this.value;
  },
  destroyed() {
    this.confirmRemove = false;
  },
  methods: {
    scheduled() {
      const self = this;
      bus.$emit('schedule-refresh');
      setTimeout(() => { self.confirmDialog = false; }, 1000);
    },
    schedule() {
      const params = {
        schedule: {
          calendarId: this.scheduleParams.calendarId,
          scheduleId: this.scheduleParams.time.id,
          date: this.scheduleParams.date,
          time: this.scheduleParams.time.time,
          speciality: this.scheduleParams.speciality,          
          calendarSpecialities: this.calendar.calendarSpecialities,
        },
        professional: {
          id: this.calendar.professionalId, // this.scheduleParams.professional.id ||
          name: this.calendar.professional,
          avatar: this.calendar.professionalAvatar,
        },
        patient: {
          id: (this.scheduleParams.patient) ? this.scheduleParams.patient.id : this.user.id,
          name: (this.scheduleParams.patient) ? this.scheduleParams.patient.name : this.user.name,
          cpf: (this.scheduleParams.patient) ? this.scheduleParams.patient.cpf : this.user.cpf,
          avatar: (this.scheduleParams.patient) ? this.scheduleParams.patient.avatar : this.user.avatar,
          confirmationWhatsapp: this.scheduleParams.patient.confirmationWhatsapp,
        },
        serviceChannel: {
          selected: this.scheduleParams.serviceChannel,
          calendarServiceChannels: this.calendar.calendarServiceChannels,
          calendarServiceChannelUrl: this.calendar.calendarServiceChannelUrl,
        },
        payment: {
          paymentAccountStatus: this.calendar.paymentAccountStatus,
          particular: this.scheduleParams.particular,
          price: this.calendar.price,
          covenant: this.scheduleParams.covenant,
        },
      };

      const queryBase64 = btoa(JSON.stringify(params));
      this.$router.push({ name: 'schedule-confirmation', query: { q: queryBase64 } });
    },
  },
  watch: {
    value(vl) {
      this.scheduleParams = vl;
    },
    date(vl) {
      this.time = null;
      this.scheduleParams.date = vl;
    },
    time(vl) {
      this.scheduleParams.time = vl;
    },
  },
  components: {
    MbTextButton,
    CalendarGetTime,
    CalendarGetDate,
    // ScheduleConfirm,
  },
};
</script>
